import { render, staticRenderFns } from "./ProductoCreateOfertaModal.vue?vue&type=template&id=4b9f6e36&scoped=true&"
import script from "./ProductoCreateOfertaModal.vue?vue&type=script&lang=js&"
export * from "./ProductoCreateOfertaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9f6e36",
  null
  
)

export default component.exports